/* Cookie js */
/*! js-cookie v3.0.0-rc.1 | MIT */
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(e=e||self,function(){var n=e.Cookies,r=e.Cookies=t();r.noConflict=function(){return e.Cookies=n,r}}())}(this,function(){"use strict";function e(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)e[r]=n[r]}return e}var t={read:function(e){return e.replace(/(%[\dA-F]{2})+/gi,decodeURIComponent)},write:function(e){return encodeURIComponent(e).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,decodeURIComponent)}};return function n(r,o){function i(t,n,i){if("undefined"!=typeof document){"number"==typeof(i=e({},o,i)).expires&&(i.expires=new Date(Date.now()+864e5*i.expires)),i.expires&&(i.expires=i.expires.toUTCString()),t=encodeURIComponent(t).replace(/%(2[346B]|5E|60|7C)/g,decodeURIComponent).replace(/[()]/g,escape),n=r.write(n,t);var c="";for(var u in i)i[u]&&(c+="; "+u,!0!==i[u]&&(c+="="+i[u].split(";")[0]));return document.cookie=t+"="+n+c}}return Object.create({set:i,get:function(e){if("undefined"!=typeof document&&(!arguments.length||e)){for(var n=document.cookie?document.cookie.split("; "):[],o={},i=0;i<n.length;i++){var c=n[i].split("="),u=c.slice(1).join("=");'"'===u[0]&&(u=u.slice(1,-1));try{var f=t.read(c[0]);if(o[f]=r.read(u,f),e===f)break}catch(e){}}return e?o[e]:o}},remove:function(t,n){i(t,"",e({},n,{expires:-1}))},withAttributes:function(t){return n(this.converter,e({},this.attributes,t))},withConverter:function(t){return n(e({},this.converter,t),this.attributes)}},{attributes:{value:Object.freeze(o)},converter:{value:Object.freeze(r)}})}(t,{path:"/"})});

// Main Box Module
const box = (() => {
  // Private state
  const state = {
    currentVariant: null,
    variantData: null,
    options: [],
    section: null,
    url: null
  };

  // Selectors object
  const selectors = {
    variants: 'input[name="size"]',
    buildABox: 'build-a-box',
    quantityInput: '.input_qty',
    quantityButton: '.btn_qty',
    variantsElement: 'build-a-box-variants',
    bottlesCount: 'current-number-of-bottles',
    boxPercentage: 'build-a-box-progress'
  };

  // Cache DOM elements
  const cache = {
    buildABoxElement: null,
    modalFooter: null,
    boxContents: null,
    pageAddButton: null
  };

  // Initialize cache
  const initCache = () => {
    cache.buildABoxElement = document.getElementById(selectors.buildABox);
    cache.modalFooter = document.querySelector('.modal__footer');
    cache.boxContents = document.getElementById('build-a-box-contents');
    cache.pageAddButton = document.querySelector('#page-add-box-to-cart');
  };

  // Utility functions
  const utils = {
    pluralize: (num, singular, plural) => num === 1 ? singular : plural,
    
    generateID: () => {
      const timestamp = new Date().getTime();
      return `_${timestamp}${Math.random().toString(36).substr(2, 9)}`;
    },

    createElement: ({ tag, appendTo, replaceContentsOf, children = [], attributes = {}, events = {} }) => {
      const element = document.createElement(tag);

      Object.entries(attributes).forEach(([key, value]) => {
        if (key.startsWith('data')) {
          element.dataset[key.replace('data', '').toLowerCase()] = value;
        } else {
          element[key] = value;
        }
      });

      Object.entries(events).forEach(([key, value]) => {
        element.addEventListener(key, value);
      });

      if (appendTo) appendTo.appendChild(element);
      if (replaceContentsOf) {
        replaceContentsOf.innerHTML = '';
        replaceContentsOf.appendChild(element);
      }

      children.forEach(child => element.appendChild(child));
      return element;
    }
  };

  // API functions
  const api = {
    getCart: async () => {
      try {
        const response = await fetch('/cart.js');
        return await response.json();
      } catch (error) {
        console.error('Cart fetch error:', error);
        return null;
      }
    },

    addToCart: async (data) => {
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(data)
        });
        return await response.json();
      } catch (error) {
        console.error('Add to cart error:', error);
        throw error;
      }
    },

    updateCart: async (variantId, quantity) => {
      try {
        const response = await fetch(`/cart/update?updates[${variantId}]=${quantity}`, {
          method: 'POST'
        });
        return await response.json();
      } catch (error) {
        console.error('Update cart error:', error);
        throw error;
      }
    }
  };

  // Variant functions
  const variants = {
    updateOptions: () => {
      const fieldsets = Array.from(document.querySelectorAll('fieldset'));
      state.options = fieldsets.map(fieldset => 
        Array.from(fieldset.querySelectorAll('input'))
          .find(radio => radio.checked)?.value
      ).filter(Boolean);
    },

    getVariantData: () => {
      if (!state.variantData) {
        const variantsEl = document.getElementById(selectors.variantsElement);
        const jsonEl = variantsEl?.querySelector('[type="application/json"]');
        state.variantData = jsonEl ? JSON.parse(jsonEl.textContent) : [];
      }
      return state.variantData;
    },

    updateMasterId: () => {
      state.currentVariant = variants.getVariantData().find(variant => 
        variant.options.every((option, index) => state.options[index] === option)
      );
    },

    updateURL: () => {
      if (!state.currentVariant) return;
      window.history.replaceState({}, '', `${state.url}?variant=${state.currentVariant.id}`);
    },

    renderProductInfo: async () => {
      if (!state.currentVariant) return;

      try {
        const response = await fetch(
          `${state.url}?variant=${state.currentVariant.id}&section_id=${state.section}`
        );
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        
        const updates = [
          { id: `price-${state.section}`, selector: `price-${state.section}` },
          { id: 'total-number-of-bottles', selector: 'total-number-of-bottles' }
        ];

        updates.forEach(({ id }) => {
          const dest = document.getElementById(id);
          const src = html.getElementById(id);
          if (src && dest) dest.innerHTML = src.innerHTML;
        });
      } catch (error) {
        console.error('Render product info error:', error);
      }
    },

    onChange: () => {
      variants.updateOptions();
      state.previousVariant = state.currentVariant;
      variants.updateMasterId();

      if (state.currentVariant) {
        variants.updateURL();
        variants.renderProductInfo();
        quantities.clear();
        ui.updateBottleCount();
      }
    }
  };

  // Quantity management
  const quantities = {
    getContents: () => {
      const inputs = document.querySelectorAll(selectors.quantityInput);
      return Array.from(inputs).reduce((total, input) => {
        const ratio = parseFloat(input.parentNode.dataset.ratio);
        return total + parseInt(input.value) / ratio;
      }, 0);
    },

    getSize: () => {
      const checked = document.querySelector('[name="size"]:checked');
      return checked ? parseInt(checked.value) : 0;
    },

    updateQuantity: (quantityEl, delta, size) => {
      const ratio = parseFloat(quantityEl.dataset.ratio);
      const input = quantityEl.querySelector('input');
      const currentValue = parseInt(input.value);
      const newValue = currentValue + (delta * ratio);
      const bottlesInBox = quantities.getContents();

      if (delta > 0) {
        if (1 + bottlesInBox <= size) {
          if (!isNaN(newValue) && newValue > 0) {
            input.value = newValue;
            quantityEl.classList.add('bottle-in-the-box');
          }
        } else {
          MicroModal.show('build-a-box-modal');
        }
      } else {
        if (!isNaN(newValue) && newValue > 0) {
          input.value = newValue;
          quantityEl.classList.add('bottle-in-the-box');
        } else {
          const label = quantityEl.parentNode.querySelector('.in-cart-labels');
          label?.remove();
          input.value = 0;
          quantityEl.classList.remove('bottle-in-the-box');
        }

        if (quantities.getContents() === 0) {
          ui.setEmptyModal();
        }
      }
    },

    onButtonClick: function(event) {
      event.preventDefault();
      const size = quantities.getSize();
      const delta = this.classList.contains('plus') ? 1 : -1;
      
      quantities.updateQuantity(this.parentNode, delta, size);
      ui.updateBoxContents(size);
      
      if (quantities.getContents() === size) {
        MicroModal.show('build-a-box-modal');
      }
      
      ui.updateBottleCount();
    },

    onModalButtonClick: function(event) {
      event.preventDefault();
      const size = quantities.getSize();
      const modalQuantityEl = this.parentNode;
      const quantityEl = document.querySelector(
        `.quantity[data-variant="${modalQuantityEl.dataset.variant}"]`
      );
      const delta = this.classList.contains('plus') ? 1 : -1;
      
      quantities.updateQuantity(quantityEl, delta, size);
      
      const modalInput = modalQuantityEl.querySelector('input');
      const mainInput = quantityEl.querySelector('input');
      modalInput.value = mainInput.value;
      
      ui.updateBottleCount();
    },

    clear: () => {
      const currentSize = state.currentVariant ? parseInt(state.currentVariant.title) : 0;
      const inputs = document.querySelectorAll('.input_qty');
      const previousSize = Array.from(inputs)
        .reduce((sum, input) => sum + (parseInt(input.value) || 0), 0);

      if (currentSize < previousSize) {
        inputs.forEach(input => input.value = 0);
        document.querySelectorAll('.in-cart-labels').forEach(label => label.remove());
        
        if (cache.pageAddButton) {
          cache.pageAddButton.disabled = true;
          cache.pageAddButton.classList.add('disabled');
        }
        
        ui.setEmptyModal();
      }
    }
  };

  // UI management
  const ui = {
    updateBottleCount: () => {
      const count = quantities.getContents();
      const size = quantities.getSize();
      const availableBottles = size - count;
      const message = `${count} of ${size}`;
      
      // Update progress bar
      const progress = document.querySelector('#build-a-box-progress');
      if (progress) {
        progress.style.width = `${(count * 100) / size}%`;
      }

      // Update messages
      document.querySelectorAll('.bottles-count-message')
        .forEach(el => el.innerHTML = message);
      
      const emptyBoxMsg = document.querySelector('#empty-box-message');
      if (emptyBoxMsg) {
        emptyBoxMsg.innerHTML = message ? `<span>${message}</span>` : '';
      }

      ui.updateModalFooter(availableBottles, size);
    },

    updateModalFooter: (availableBottles, size) => {
      if (!cache.modalFooter) return;
      
      cache.modalFooter.innerHTML = '';
      const isComplete = availableBottles <= 0;

      // Add button
      utils.createElement({
        tag: 'button',
        attributes: {
          className: 'add-box-to-cart',
          type: 'button',
          textContent: 'Add Box to Cart',
          disabled: !isComplete
        },
        appendTo: cache.modalFooter,
        events: {
          click: async (e) => {
            e.preventDefault();
            await cart.submitBox();
          }
        }
      });

      // Upgrade button (if applicable)
      if (isComplete) {
        const nextVariant = ui.getNextVariant();
        if (nextVariant) {
          utils.createElement({
            tag: 'button',
            attributes: {
              className: 'upgrade-box',
              type: 'button',
              textContent: `Upgrade to ${nextVariant.size}`,
              disabled: false
            },
            appendTo: cache.modalFooter,
            events: {
              click: (e) => {
                e.preventDefault();
                ui.upgradeBox(nextVariant.element);
              }
            }
          });
        }
      }

      // Back button
      // utils.createElement({
      //   tag: 'button',
      //   attributes: {
      //     className: 'close-modal-button',
      //     type: 'button',
      //     textContent: 'Back to product',
      //     datamicromodalClose: true
      //   },
      //   appendTo: cache.modalFooter
      // });

      // Update page button
      if (cache.pageAddButton) {
        cache.pageAddButton.disabled = !isComplete;
        cache.pageAddButton.classList.toggle('disabled', !isComplete);
      }
    },

    getNextVariant: () => {
      const variants = Array.from(document.querySelectorAll('[name="size"]'));
      const checkedIndex = variants.findIndex(v => v.checked);
      const nextVariant = variants[checkedIndex + 1];
      
      return nextVariant ? {
        size: parseInt(nextVariant.value),
        element: nextVariant
      } : null;
    },

    upgradeBox: (nextVariantInput) => {
      nextVariantInput.checked = true;
      nextVariantInput.dispatchEvent(new Event('change', { bubbles: true }));
      ui.updateBoxContents();
      ui.updateBottleCount();
    },

    updateBoxContents: () => {
      if (!cache.boxContents) return;
      
      cache.boxContents.innerHTML = '';
      const products = document.querySelectorAll('.bottle-in-the-box');

      products.forEach(product => {
        const data = {
          title: product.dataset.title,
          image: product.dataset.image,
          ingredients: product.dataset.ingredients,
          variant: product.dataset.variant,
          quantity: product.querySelector('.input_qty').value,
          ratio: product.dataset.ratio
        };

        ui.createProductItem(data);
      });
    },

    createProductItem: (data) => {
      const li = utils.createElement({
        tag: 'li',
        appendTo: cache.boxContents
      });

      // Image
      const imageContainer = utils.createElement({
        tag: 'div',
        attributes: { className: 'image' },
        appendTo: li
      });

      utils.createElement({
        tag: 'img',
        attributes: { src: data.image, alt: data.title },
        appendTo: imageContainer
      });

      // Content
      const contentContainer = utils.createElement({
        tag: 'div',
        attributes: { className: 'content' },
        appendTo: li
      });

      utils.createElement({
        tag: 'div',
        attributes: { className: 'title', textContent: data.title },
        appendTo: contentContainer
      });

      utils.createElement({
        tag: 'div',
        attributes: { className: 'ingredients', textContent: data.ingredients },
        appendTo: contentContainer
      });

      // Quantity controls
      const quantityContainer = utils.createElement({
        tag: 'div',
        attributes: {
          className: 'modal-quantity',
          datatitle: data.title,
          dataimage: data.image,
          dataingredients: data.ingredients,
          datavariant: data.variant,
          dataratio: data.ratio
        },
        appendTo: li
      });

      // Minus button
      utils.createElement({
        tag: 'button',
        attributes: {
          type: 'button',
          className: 'modal-btn_qty minus',
          textContent: '-'
        },
        appendTo: quantityContainer,
        events: { click: quantities.onModalButtonClick }
      });

      // Input
      utils.createElement({
        tag: 'input',
        attributes: {
          type: 'number',
          className: 'modal-input_qty',
          value: data.quantity,
          readOnly: true
        },
        appendTo: quantityContainer
      });

      // Plus button
      utils.createElement({
        tag: 'button',
        attributes: {
          type: 'button',
          className: 'modal-btn_qty plus',
          textContent: '+'
        },
        appendTo: quantityContainer,
        events: { click: quantities.onModalButtonClick }
      });
    },

    setEmptyModal: () => {
      if (!cache.boxContents || !cache.modalFooter) return;
      
      cache.boxContents.innerHTML = '';
      cache.modalFooter.innerHTML = '';

      utils.createElement({
        tag: 'li',
        attributes: {
          textContent: 'Your box is empty.',
          style: 'justify-content: center;'
        },
        appendTo: cache.boxContents
      });

      // const li = utils.createElement({
      //   tag: 'li',
      //   appendTo: cache.boxContents
      // });

      // utils.createElement({
      //   tag: 'button',
      //   attributes: {
      //     textContent: 'Back to product',
      //     type: 'button',
      //     className: 'close-modal-button',
      //     datamicromodalClose: true
      //   },
      //   appendTo: li
      // });
    },

    setupSticky: () => {
      const boxElement = cache.buildABoxElement;
      if (!boxElement) return;

      const boxParent = boxElement.parentNode;
      const header = document.querySelector('#store-header');
      const announcement = document.querySelector('.buy-more-save-more');
      
      if (!header || !announcement) return;

      const boxHeight = boxElement.offsetHeight;

      window.addEventListener('scroll', () => {
        if (window.scrollY > boxHeight) {
          boxParent.style.height = `${boxHeight}px`;
          boxElement.classList.add('sticky');
        } else {
          boxParent.style.height = 'auto';
          boxElement.classList.remove('sticky');
        }
      });
    }
  };

  // Cart management
  const cart = {
    getSelectedVariant: () => {
      const checked = document.querySelector('[name="size"]:checked');
      return checked ? parseInt(checked.dataset.variant) : null;
    },

    submitBox: async () => {
      const selectedVariant = cart.getSelectedVariant();
      if (!selectedVariant) return;

      cart.setButtonState(true, 'Adding...');

      try {
        const data = cart.prepareCartData(selectedVariant);
        await api.addToCart(data);
        window.location = '/cart';
      } catch (error) {
        cart.setButtonState(false, 'Add Box to Cart');
        console.error('Submit box error:', error);
      }
    },

    setButtonState: (disabled, text) => {
      const addButton = document.querySelector('.add-box-to-cart');
      if (addButton) {
        addButton.disabled = disabled;
        addButton.innerHTML = text;
      }

      if (cache.pageAddButton) {
        cache.pageAddButton.disabled = disabled;
        cache.pageAddButton.classList.toggle('disabled', disabled);
        cache.pageAddButton.innerHTML = text;
      }
    },

    prepareCartData: (selectedVariant) => {
      const boxID = cache.buildABoxElement?.dataset.boxid || utils.generateID();
      const bottles = document.querySelectorAll('.bottle-in-the-box');
      const properties = { _boxID: boxID };
      let contents = '';

      Array.from(bottles).forEach((bottle, index) => {
        const quantity = parseInt(bottle.querySelector('input').value);
        if (quantity > 0) {
          const letterLabel = String.fromCharCode(65 + index); 
      
          properties[`_${letterLabel}`] = `${bottle.dataset.handle} | ${quantity}`;
          //properties[`_${index + 1}`] = `${bottle.dataset.handle} | ${quantity}`;
          contents += `${quantity}x ${bottle.dataset.title} `;
        }
      });

      properties[`Contents`] = contents;

      return {
        items: [{
          id: selectedVariant,
          quantity: 1,
          properties
        }]
      };
    }
  };

  // Local storage management
  const storage = {
    check: () => {
      const juicesString = localStorage.getItem('juicesFromTheBox');
      if (!juicesString) return;

      try {
        const juices = JSON.parse(juicesString);
        Object.entries(juices).forEach(([handle, quantity]) => {
          if (quantity > 0) {
            const element = document.querySelector(`[data-handle="${handle}"]`);
            if (element) {
              const input = element.querySelector('input');
              element.classList.add('bottle-in-the-box');
              input.value = quantity;
            }
          }
        });

        localStorage.removeItem('juicesFromTheBox');
        ui.updateBoxContents();
        ui.updateBottleCount();
        MicroModal.show('build-a-box-modal');
      } catch (error) {
        console.error('Local storage error:', error);
      }
    }
  };

  // Initialization
  const init = () => {
    initCache();
    
    if (!cache.buildABoxElement) {
      console.error('Build-a-box element not found');
      return;
    }

    state.section = cache.buildABoxElement.dataset.section;
    state.url = cache.buildABoxElement.dataset.url;

    // Event listeners
    document.querySelectorAll(selectors.variants)
      .forEach(el => el.addEventListener('change', variants.onChange));

    document.querySelectorAll(selectors.quantityButton)
      .forEach(el => el.addEventListener('click', quantities.onButtonClick));

    if (cache.pageAddButton) {
      cache.pageAddButton.addEventListener('click', (e) => {
        e.preventDefault();
        cart.submitBox();
      });
    }

    // Check URL params
    const params = new URLSearchParams(window.location.search);
    if (params.get('show-box') === 'true') {
      ui.updateBoxContents();
      ui.updateBottleCount();
      MicroModal.show('build-a-box-modal');
    }

    storage.check();
    ui.setupSticky();
  };

  // Public API
  return {
    init,
    selectors,
    updateBoxContents: ui.updateBoxContents,
    updateBottleCount: ui.updateBottleCount
  };
})();

// Initialize when DOM is ready
box.init();